import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { DbService } from '../../db.service';
import { SpinnerService } from '../../spinner.service';

import { IndicacaoAmigo } from './_indicacao-amigo.class';

@Component({
    selector: 'app-home-indicacao-amigo',
    templateUrl: './_indicacao-amigo.component.html',
    styleUrls: ['./_indicacao-amigo.component.css']
})

export class Home_IndicacaoAmigoComponent {
    form: FormGroup;
    item: IndicacaoAmigo = new IndicacaoAmigo();
    showConfirmacao: boolean = false;
    showErro: boolean = false;

    constructor(
        private dbService: DbService,
        private router: Router,
        private spinnerService: SpinnerService
    ) {
        this.form = new FormGroup({
            nmRemetente: new FormControl('', Validators.required),
            nmDestinatario: new FormControl('', Validators.required),
            dsEmailDestinatario: new FormControl('', [Validators.required, Validators.email])
        });
    }

    fnCadastrar() {
        this.showConfirmacao = false;
        this.showErro = false;

        // Valida formulário
        if (!this.form.valid) {
            // Exibe erros
            for (let ctrl in this.form.controls) { this.form.controls[ctrl].markAsTouched(); }
        } else {
            this.dbService.post('IndicacaoAmigo', this.item).subscribe(result => {
                // Encerra spinner
                this.spinnerService.stop();

                // Exibe notificação
                if (result.confirmacao === true) {
                    this.form.reset();
                    this.showConfirmacao = true;
                } else {
                    this.showErro = true;
                }
            });
        }
    }
}
